
        import 'QuoteAndBuy.f00e2e7.css-module'
        export default {"header":"header_QuoteAndBuy_f00e2e7"}
    